export const IDENTITY_MOCK = {
  token: 'TEST',
  userId: 'TEST_ID',
  firstName: 'TEST_FIRST_NAME',
  lastName: 'TEST_LAST_NAME',
  email: 'email@test.com',
};
